import { BestSellersByChannelsContainer } from './BestSellersByChannelsContainer';
import { SalesByChannelsPieContainer } from './SalesByChannelsPieContainer';
import { SalesByTopChannelsGraphContainer } from './SalesByTopChannelsGraphContainer';

import styles from './AnalyticsGraphs.module.scss';

export function AnalyticsGraphs() {
  return (
    <div className={styles.analyticsGraphs}>
      <div className={styles.graphsRow}>
        <div className={styles.twoThirds}>
          <BestSellersByChannelsContainer />
        </div>
        <div className={styles.oneThird}>
          <SalesByChannelsPieContainer />
        </div>
      </div>
      <div className={styles.graphsRow}>
        <div className={styles.fullRow}>
          <SalesByTopChannelsGraphContainer />
        </div>
      </div>
    </div>
  );
}
